import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} viewBox='0 0 149.82 135.14' onClick={onClick} width={size} height={size} className={className} fill={fillColor}>
      <path d='M133.86,33.84a17.15,17.15,0,0,0-4.67-.65H71a17.32,17.32,0,0,0-4.67.65L100.07,92Z' transform='translate(-25.16 -33.19)' />
      <path d='M25.16,105.17l31.29,55a17.3,17.3,0,0,0,2.87,3.73l33.41-58.75Z' transform='translate(-25.16 -33.19)' />
      <path d='M143.7,160.19l31.29-55H107.42l33.41,58.76a17.07,17.07,0,0,0,2.87-3.74' transform='translate(-25.16 -33.19)' />
      <path
        d='M66.29,167.69a17.32,17.32,0,0,0,4.67.64h58.23a17.32,17.32,0,0,0,4.67-.64l-33.78-58.12Z'
        transform='translate(-25.16 -33.19)'
      />
      <path d='M175,96.36l-31.29-55a17.39,17.39,0,0,0-2.87-3.74L107.42,96.36Z' transform='translate(-25.16 -33.19)' />
      <path d='M56.51,42.1l-31.35,55,67.57.06L59.37,38.36a17,17,0,0,0-2.86,3.74' transform='translate(-25.16 -33.19)' />
    </svg>
  );
});

export default React.memo(Icon);
